module.exports = __webpack_public_path__ + "img/crystal@2x.4b14459.jpg";